import { resolveEndpoint } from '@/lib/services'

export const REALM = 'master'

export const getCustomerLoginUrl = (shortName: string, customerUrl: string) => {
    const keycloakHost = resolveEndpoint('KeycloakService')
    const loginUrl = `${keycloakHost}/auth/realms/${shortName}/protocol/openid-connect/auth?&scope=profile email openid&response_type=code&approval_prompt=auto&redirect_uri=${customerUrl}&client_id=back_2cloud&kc_idp_hint=${REALM}`

    return encodeURI(loginUrl)
}
